import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../utils/supabase';

/**
 * VALookup component
 * This component handles redirecting to the correct public profile page
 * It fetches the public_username based on the VA's ID and redirects to the public profile page
 */
const VALookup = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const lookupVA = async () => {
      if (!id) {
        setError('No VA ID provided');
        setIsLoading(false);
        return;
      }

      try {
        // Fetch the public_username based on the VA's ID
        const { data, error } = await supabase
          .from('user_profiles')
          .select('public_username')
          .eq('id', id)
          .eq('role', 'va')
          .single();

        if (error) throw error;

        if (data && data.public_username) {
          // Redirect to the public profile page using the public_username
          navigate(`/va/${data.public_username}`, { replace: true });
        } else {
          // If no public_username is found, show an error
          setError('VA profile not found');
          setIsLoading(false);
        }
      } catch (err) {
        console.error('Error looking up VA:', err);
        setError('Error looking up VA profile');
        setIsLoading(false);
      }
    };

    lookupVA();
  }, [id, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-gray-600">Looking up VA profile...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center max-w-md mx-auto px-4">
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            <strong className="font-bold">Profile Not Found</strong>
            <p className="block">{error}</p>
          </div>
          <button 
            onClick={() => navigate('/')} 
            className="bg-primary hover:bg-primary-600 text-white font-bold py-2 px-4 rounded"
          >
            Return to Home
          </button>
        </div>
      </div>
    );
  }

  // This should never be shown as we redirect immediately when data is loaded
  return null;
};

export default VALookup;
